import React, { useState } from "react";
import AllAnnouncements from "./all-announcements";
import IqamahAnnouncements from "./iqamah-announcements";
import { useGetannouncementQuery } from "../../../store/Reducer/annocements";
import TableFilters from "../user-events/table/table-filters";
import Button from "../../../components/buttons/button";
import { Header } from "../../../components/page-header/Header";
import { useTranslation } from "react-i18next";

const UserAnnouncements = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("all");
  const [search, setSearch] = useState(""); // Added search state
  const [currentPage, setCurrentPage] = useState(1); // Assuming currentPage is a state

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  // Fetch data
  const {
    data: announcementsData,
    isLoading,
    error,
  } = useGetannouncementQuery({ page: currentPage, search });


  const breadcrumbItems = [
    { label: t("universal_dashboard_text"), to: '/user-dashboard' },
    { label: t("announcements_title") },
  ];


  return (
    <>
      <section className="min-h-[86vh] bg-gradient-to-b from-slate-50 to-gray-50">
        <div className="max-w-7xl mx-auto p-6">
          <div className="space-y-6">

            <div className="flex items-center justify-between">
              <Header title={t("announcements_title")} breadcrumbItems={breadcrumbItems} />
            </div>

            {/* Desktop Tabs */}
            <div className="block max-w-xs">
              <div className="border-b border-gray-200">
                <nav className="-mb-px flex gap-1 md:gap-4" aria-label="Tabs">
                  <button
                    className={`shrink-0 border-b-2 px-1 pb-4 text-sm font-medium ${activeTab === "all"
                      ? "border-sky-500 text-sky-600"
                      : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
                      }`}
                    onClick={() => handleTabClick("all")}
                  >
                    {t("announcements_tabs_all_announcements")}
                  </button>

                  <button
                    className={`shrink-0 border-b-2 px-1 pb-4 text-sm font-medium ${activeTab === "iqamah"
                      ? "border-sky-500 text-sky-600"
                      : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
                      }`}
                    onClick={() => handleTabClick("iqamah")}
                  >
                    {t("announcements_tabs_iqamah_change_announcements")}
                  </button>
                </nav>
              </div>
            </div>

            {/* Tab Content */}
            <div className="content mt-4">
              {isLoading ? (
                <div className="pt-16 flex justify-center mt-12 items-center">
                  <div
                    className="animate-spin inline-block w-8 h-8 border-[3px] border-current border-t-transparent text-gray-700 dark:text-gray-100 rounded-full"
                    role="status"
                    aria-label="loading"
                  >
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              ) : (
                <div className="mt-4">
                  {activeTab === "all" ? (
                    <AllAnnouncements />
                  ) : (
                    <IqamahAnnouncements />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </section >
    </>
  );
};

export default UserAnnouncements;
